import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import "./affliatelist.css"
import ChartCheckbox from '../../Dashboard/Tools/ChartCheckbox';
import axios from "axios";
import TableComponent from '../../Table/Table';
import Select from 'react-select'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactExport from "react-data-export";
import { CSVLink, CSVDownload } from "react-csv";
import SearchIcon from '@rsuite/icons/Search';
import { Input, InputGroup } from 'rsuite';

function Download(props) {

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


    return (
        <>
            {
                props.dataType == 0 ? (
                    <ExcelFile hideElement={true} filename="Data" fileExtension={props.dataType == 0 ? "xlsx" : "csv"}>
                        <ExcelSheet data={props.data} name="Data">
                            {
                                props.scolumns.filter(d => {
                                    return d.active == true
                                }).map(column => {
                                    return (
                                        <ExcelColumn label={column.name} value={column.key} />
                                    )
                                })
                            }
                        </ExcelSheet>
                    </ExcelFile>
                ) : (
                    <>
                        <CSVDownload data={props.csvdata} target="_blank" />;
                    </>
                )
            }
        </>
    );
}
function AffliateList() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const StoreUser = useSelector((state) => state.user);
    const [affiliatList, setAffliateList] = useState([]);
    const [approvedAffliateList, setApprovedAffliateList] = useState([]);
    const [AffliateGrp, seAffliateGrp] = useState([]);
    const [affPages, setAffPages] = useState(0)
    const [searchAffliate, setSearchAffiliate] = useState('');
    const [filterValues, setFilterValues] = useState([])
    const [affOnReview, setAffOnReview] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [ltComGrp, setLtComGrp] = useState([])
    const [ltAffGrp, setLtAffGrp] = useState([])
    const [ltLang, setLtLang] = useState([]);
    const [affliate, setAffliate] = useState({});
    const [csvdata, setCsvData] = useState([]);
    const [extype, setExtype] = useState("");
    const [downloadable, setDownloadable] = useState(false)
    const [loadingExport, setLoadingExport] = useState(false)
    const [affiliateFilter, setAffiliateFilter] = useState
        ({
            filters: {
                currency: "",
                commissiongroup: "",
                affiliategroup: "",
                language: "",
                btag: "",
                websiteid: "",
                status: "0",
                introducedId : "",
                promocode : "",
                promocodeBtag : ""
            }
        })
    const [ExportColumns, setExportColumns] = useState([
        {
            Header: 'Affiliate ID',
            accessor: 'id', // accessor is the "key" in the data
        },
        {
            Header: 'Username',
            accessor: 'username',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Email Verified',
            accessor: 'EmailVerified',
        },
        {
            Header: 'Country',
            accessor: 'country',
        },
        {
            Header: 'Site',
            accessor: 'site',
        },
        {
            Header: 'Register date',
            accessor: 'registrationdate',
        },
        {
            Header: 'Introduced By',
            accessor: 'introducedBy',
        },
        {
            Header: 'Status',
            accessor: 'status',
        },

    ])
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    const handleAffiliateSearchChange = (event) => {
        // setSearchAffiliate(event.value);

        setAffiliateFilter({
            filters : {
                ...affiliateFilter.filters,
                username : event
            }
        })

        // setAffliateList(filteredItems);
    };

    ;
    const getAllAffliates = async () => {
        setLoading(true)
        const response = await axios.post(window.__CFG.API + "affiliates/ListAffiliates?page=" + currentPage, affiliateFilter, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoading(false)
        if (response.data.Error == null) {
            setAffPages(response.data.Result.Pages)
            setAffliateList(response.data.Result.Data);
            setAffOnReview(response.data.Result.AwaitingReview)
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        getAllAffliates()
    }, [affPages, affiliateFilter, searchAffliate, currentPage])

    const columns = [
        {
            Header: 'Affiliate ID',
            accessor: 'id', // accessor is the "key" in the data
        },
        {
            Header: 'Username',
            accessor: 'username',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Email Verified',
            accessor: 'emailVerified',
        },
        {
            Header: 'Country',
            accessor: 'country',
        },
        {
            Header: 'Site',
            accessor: 'site',
        },
        {
            Header: 'Register date',
            accessor: 'registrationdate',
        },
        {
            Header: 'Introduced By',
            accessor: 'introducedBy',
        },
        {
            Header: 'Status',
            accessor: 'status',
        },

    ];

    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getListAffliateGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtAffGrp(response.data.Result)
        }
    }
    const getListCommissionGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtComGrp(response.data.Result)
        }
    }
    const getListLanguages = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtLang(response.data.Result)
        }
    }
    const optionsCurrency = [{ label: "USD", value: 1 }]
    const optionsStatus = [{ label: "Active", value: 0 }, { label: "Inactive", value: 1 }, { label: "Onreview", value: 2 }, { label: "Declined", value: 3 }]
    const optionsExport = [{ label: "CSV", value: 1 }]
    const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)
    const selectedExportValue = optionsExport.find(options => options.value === 1)

    useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); getListLanguages() }, [])
    const selectKeys = (arr, keys) => {
        return arr.map(item =>
            keys.reduce((acc, key) => {
                if (item.hasOwnProperty(key)) {
                    acc[key] = item[key];
                }
                return acc;
            }, {})
        );
    };
    const ExportData = async (type) => {
        setLoadingExport(true);

        const response = await axios.post(window.__CFG.API + "affiliates/ListAffiliates?all=true", affiliateFilter, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        });

        setLoadingExport(false);

        setExtype(type)

        if (response.data.Error == null) {
            let mcolumns = [];

            for (var k = 0; k < ExportColumns.length; k++) {
                var column = ExportColumns[k];

                mcolumns.push(column.accessor)

            }

            setCsvData(selectKeys(response.data.Result.Data, mcolumns))

            setDownloadable(true);

            setTimeout(() => {
                setDownloadable(false);
            }, 500)
        }
    }
    return (
        <>
            <div>
                <div>
                </div>
                <div>
                    <Container>
                        <Row >

                            <Col>
                                <Row className="justify-content-between mt-4">
                                    <Col lg={3} md={4} sm={5} style={{ textAlign: "end" }} className='awai-rev-mobile'>
                                        <div className="">Awaiting review : <span onClick={() => navigate("/affiliate/affreview")} className="fw-bold text-primary span-link">{affOnReview} new</span></div>

                                    </Col>
                                    <Col lg={3} md={4} sm={4}>
                                        <div className='add-affiliate-searchInput' style={{width:"100%"}}>
                                            <div className="search-container">
                                                {/* <Input style={{ padding: 4, minWidth: 190 }} onChange={handleAffiliateSearchChange} value={searchAffliate} type="text" className="search-input" placeholder="search" /> */}
                                                <InputGroup >
                                                    <Input style={{ padding: 7, width: "100%", borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} onChange={handleAffiliateSearchChange} value={affiliateFilter.filters.username} type="text" className="search-input" placeholder="Search" />
                                                    <InputGroup.Addon>
                                                        <SearchIcon />
                                                    </InputGroup.Addon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3} md={4} sm={5} style={{ textAlign: "end" }} className='awai-rev-desktop'>
                                        <div className="">Awaiting review : <span onClick={() => navigate("/affiliate/affreview")} className="fw-bold text-primary span-link">{affOnReview} new</span></div>

                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-4 me-auto w-100 alt-fm">
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div className='form-aff-list-in'>
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Currency</label>
                                            </div>
                                            <div className="dashboard-select-periode">
                                                <Select options={optionsCurrency} value={selectedCurrencyValue} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={5} className='alt-col'>
                                        <div className='form-aff-list-in'>
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Affiliate group</label>
                                            </div>
                                            <div className="dashboard-select-periode">
                                                <Select options={ltAffGrp} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliategroup: e.value } })) }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-4 me-auto w-100 alt-fm">
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div className='form-aff-list-in'>
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Commission group</label>
                                            </div>
                                            <div className="dashboard-select-periode">
                                                <Select options={ltComGrp} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, commissiongroup: e.value } })) }} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={5} className='alt-col'>
                                        <div className='form-aff-list-in'>
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Language</label>
                                            </div>
                                            <div className="dashboard-select-periode">
                                                <Select options={ltLang} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, language: e.value } })) }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-4 me-auto w-100 alt-fm">
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                            <label>Website ID</label>
                                        </div>
                                        <Form.Control value={affiliateFilter.filters.websiteid} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, websiteid: e.target.value } })) }} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} />
                                    </Col>
                                    <Col lg={4} md={4} sm={5} className='alt-col'>
                                        <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                            <label>Introduced By (BTAG)</label>
                                        </div>
                                        <Form.Control value={affiliateFilter.filters.btag} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, btag: e.target.value } })) }} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} />
                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-4 me-auto w-100 alt-fm">
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                            <label>Introduced By (ID)</label>
                                        </div>
                                        <Form.Control value={affiliateFilter.filters.introducedId} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, introducedId: e.target.value } })) }} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} />
                                    </Col>
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                            <label>Promocode</label>
                                        </div>
                                        <Form.Control value={affiliateFilter.filters.promocode} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, promocode: e.target.value } })) }} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} />
                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-4 me-auto w-100 alt-fm">
                                    <Col lg={4} md={4} sm={4} className='alt-col'>
                                        <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                            <label>Promocode (BTAG)</label>
                                        </div>
                                        <Form.Control value={affiliateFilter.filters.promocodeBtag} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, promocodeBtag: e.target.value } })) }} type="text" style={{ width: "100%", padding: 4, borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} />
                                    </Col>
                                    <Col lg={4} md={4} sm={5} className='alt-col'>
                                        <div className='form-aff-list-in'>
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Status</label>
                                            </div>
                                            <div className="dashboard-select-periode">

                                                <Select options={optionsStatus} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, status: e.value } })) }} placeholder="status" />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-4 me-4 w-100">
                                    <div className='export-aff'>
                                        <div style={{ flex: 1 }} className="dashboard-select-periode">
                                            <Select options={optionsExport} placeholder="export type" value={selectedExportValue} />
                                        </div>
                                        <div style={{ marginLeft: 10 }} className='aff-exp-btn'>
                                            <button disabled={loadingExport} onClick={() => ExportData(1)}>
                                                {!loadingExport ? (<>Export</>) : (<><Spinner size="sm"></Spinner> </>)}
                                            </button>
                                        </div>
                                    </div>
                                </Row>
                                <Row className="mt-4 mb-4">
                                    <div className="aff-dash-summary-table">

                                        <TableComponent columns={columns} data={affiliatList} Pages={affPages} currentPage={currentPage} onPageChange={handlePageChange} loading={loading} ActionLink={(row) => `/affiliate/details?id=` + row.id} navigationColumn={checkPermission(affliate, "aff_edit_affiliates") ? "id" : ""} />
                                    </div>
                                </Row>
                                {
                                    downloadable ? (
                                        <Download scolumns={ExportColumns} dataType={extype} csvdata={csvdata} data={affiliatList} />
                                    ) : (
                                        <></>
                                    )
                                }


                            </Col>
                        </Row>


                    </Container>
                </div>
            </div>
        </>
    )
}

export default AffliateList